<template>
  <custom-dialog
    :title="model.title"
    width="1550px"
    :visible="visible"
    :append-to-body="true"
    v-on="$listeners"
    class="accounts-registration-dialog"
  >
    <div
      class="dialog-body"
      v-loading="relatedBillLoading"
    >
      <div class="info-container">
        <div class="l">
          <bill-container :title="$t('fms_accounts_registration_dialog.zhang_dan_lie_biao')">
            <accounts-registration-accounts-bill
              v-model="billList"
              :orderNum="getPaymentCode(registerMsg)"
              ref="payableBill"
              :auth="accountPayableAuth"
              :isLockBill="isLockBill"
              :paymentOrReceivable="paymentOrReceivable"
              :loading="relatedBillLoading"
              @add="onAddBills"
              @delete="onDeleteBill"
            ></accounts-registration-accounts-bill>
          </bill-container>
          <bill-container :title="$t('fms_accounts_registration_dialog.zhi_fu_xin_xi')">
            <accounts-registration-msg-bill
              v-model="tradeList"
              :outerItem="firstOrderItem"
              ref="msgBill"
              :orderNum="getPaymentCode(registerMsg)"
              :payableTotal="payableTotal"
              :billInfo="registerMsg"
              @store="onMsgStore"
              :paymentOrReceivable="paymentOrReceivable"
              :balance="registerMsg.balance"
              :isUseBalance="useRest"
              :auth="msgBillAuth"
              :accountManage="accountManage"
            ></accounts-registration-msg-bill>
          </bill-container>
        </div>
        <div class="r">
          <div class="pay-info">
            <div class="title">{{ $t('fms_accounts_registration_dialog.zhi_fu_xiang_qing') }}</div>
            <div class="order-code">
              <div class="label">{{ $t('fms_accounts_registration_dialog.ding_dan_bian_hao') }}:</div>
              <div class="value">{{getPaymentCode(registerMsg)}}</div>
            </div>
            <!-- 收款时显示 -->
            <div
              class="order-code"
              v-if="!paymentOrReceivable"
            >
              <div class="label">{{ $t('fms_accounts_registration_dialog.fu_kuan_fang') }}:</div>
              <div class="value">{{firstOrderItem.payableOrgName}}</div>
            </div>
            <div
              class="order-code"
              v-else
            >
              <div class="label">{{ $t('fms_accounts_registration_dialog.shou_kuan_fang') }}:</div>
              <div class="value">{{firstOrderItem.receivableOrgName}}</div>
            </div>
            <div class="group-list">
              <div class="group">
                <div class="rest">
                  <div class="label">{{!paymentOrReceivable ? $t('fms_accounts_registration_dialog.fu_kuan_fang_yu_e') : $t('fms_accounts_registration_dialog.zu_lin_yu_e')}}</div>
                  <div class="value">￥{{registerMsg.balance}}</div>
                  <div class="use-rest">
                    <div class="use-label">{{ $t('fms_accounts_registration_dialog.shi_yong') }}</div>
                    <div class="use-cb">
                      <el-checkbox v-model="useRest"></el-checkbox>
                    </div>
                  </div>
                </div>
              </div>
              <div class="group">
                <div class="amount">
                  <div class="should-pay">
                    <span class="bold">{{ $t('fms_accounts_registration_dialog.shi_fu_jin_e') }}:</span>
                    ￥{{actualPayAmount}}
                  </div>

                  <div class="details">
                    <div class="item">
                      <div class="key">{{ $t('fms_accounts_registration_dialog.zu_lin_yu_e') }}</div>
                      <div class="val">￥{{expectUseRest || 0}}</div>
                    </div>
                    <div class="item">
                      <div class="key">{{ $t('fms_accounts_registration_dialog.dui_gong_zhuan_zhang') }}</div>
                      <div class="val">￥{{publicAmount}}</div>
                    </div>
                    <div class="item">
                      <div class="key">{{ $t('fms_accounts_registration_dialog.xian_jin_zhi_fu') }}</div>
                      <div class="val">￥{{cashAmount}}</div>
                    </div>
                  </div>
                  <div class="actual-pay">
                    <div class="key bold">{{ $t('fms_accounts_registration_dialog.ying_fu_jin_e') }}：</div>
                    <div class="val">￥{{payableTotal}}</div>
                  </div>
                  <div
                    class="should-pay"
                    v-if="thisRest"
                  ><span class="bold">{{ $t('fms_accounts_registration_dialog.ben_ci_jie_yu') }}：</span>￥{{thisRest}}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      class="dialog-footer"
      slot="footer"
    >
      <el-button @click="onCancel">{{ $t('Common.com_close') }}</el-button>
      <el-button
        v-if="cancelRegister && firstOrderItem && [1, 90].includes(firstOrderItem.billTradeState || firstOrderItem.tradeState)"
        type="primary"
        @click="onCancelOrder"
      >{{ $t('fms_accounts_registration_dialog.qu_xiao_deng_ji') }}</el-button>
      <el-button
        @click="onStore"
        type="primary"
      >{{ $t('fms_accounts_registration_dialog.zan_cun') }}</el-button>
      <el-button
        @click="onConfirm"
        type="primary"
      >{{ $t('Common.com_confirm') }}</el-button>
    </div>
  </custom-dialog>
</template>

<script>
/** 付款/收款-登记(账单收付款的登记都是这个dialog) */

import apis from '@/utils/apis';
import dialogMixins from '@/mixins/dialog_mixins';
import commonDialogMixin from './dialogMixin';
import billContainer from './bill_container';
import accountsRegistrationAccountsBill from './accounts_registration_accounts_bill';
import accountsRegistrationMsgBill from './accounts_registration_msg_bill';
import mixins from './mixins';

export default {
  name: '',
  mixins: [dialogMixins, commonDialogMixin, mixins],
  components: {
    billContainer,
    accountsRegistrationAccountsBill,
    accountsRegistrationMsgBill,
  },
  props: {
    // model: {
    //   data: {
    //     // 选中的rows
    //     // billData: []
    //   }
    // }
    // false-收款  true-付款
    paymentOrReceivable: {
      type: Boolean,
      default: false,
    },
    // 取消登记
    cancelRegister: {
      type: Boolean,
      default: true,
    },
    // 添加账单
    addBill: {
      type: Boolean,
      default: true,
    },
    // 删除账单
    delBill: {
      type: Boolean,
      default: true,
    },
    // 是否新增交易信息
    addTradeMsg: {
      type: Boolean,
      default: true,
    },
    // 是否编辑交易信息
    editTradeMsg: {
      type: Boolean,
      default: true,
    },
    // 是否删除交易信息
    delTradeMsg: {
      type: Boolean,
      default: true,
    },
    // 是否确认收款
    confirmCollection: {
      type: Boolean,
      default: true,
    },
    // 权限-账户管理, 默认有
    accountManage: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      name: 'accountsRegistrationDialog',
      isLockBill: false,
      registerMsg: {
        balance: 0,
        deposit: '',
        billPaymentCode: '',
      },
      // 应付款账单信息
      billList: [],
      // 付款信息
      tradeList: [],
      userType: [],
      firstOrderItem: {},
      useRest: false,
      // 是否正在查询关联赠送账单
      relatedBillLoading: false,
      // 是否正在submiting
      submiting: false,
    };
  },
  computed: {
    // 账单合计 - 支付信息合计
    accountDiff() {
      // 支付金额总和
      const total = this.total || 0;
      // 账单金额总和
      const payableTotal = this.payableTotal || 0;
      return payableTotal - total;
    },
    // 本次结余 实付金额-应付金额，若本次结余为0时不显示此行）
    thisRest() {
      const actualPayAmount = this.actualPayAmount || 0;
      const payableTotal = this.payableTotal || 0;
      return Math.max(actualPayAmount - payableTotal, 0);
    },
    msgBillAuth() {
      const fullAuth = [
        // 编辑
        'edit',
        // 删除
        'del',
        // 添加 付款/收款信息
        'addPayMsg',
      ];
      const map = {
        addPayMsg: this.addTradeMsg,
        edit: this.editTradeMsg,
        del: this.delTradeMsg,
      };
      const ret = fullAuth.filter((auth) => map[auth] !== false);
      return ret;
    },

    // 支付金额总和
    total() {
      return this.getBillTotal();
    },
    // 账单总金额
    payableTotal() {
      return this.getAccountTotal();
    },
    accountPayableAuth() {
      let ret = ['del', 'addPayableOrder', 'copy'];
      if (this.billList && this.billList.length) {
        const firstItem = this.billList[0];
        if (firstItem.isLockBill) {
          ret = ['copy'];
        }
      }
      const map = {
        del: this.delBill,
        addPayableOrder: this.addBill,
      };
      ret = ret.filter((auth) => map[auth] !== false);
      return ret;
    },
    balance() {
      return this.registerMsg.balance;
    },
    // 预计使用余额
    expectUseRest() {
      // // 是否使用余额
      // const useRest = this.useRest;
      // // 账单总额
      // const accountTotal = this.getAccountTotal();
      // // 现有余额
      // const balance = this.registerMsg.balance || 0;
      // if (!useRest) {
      //   return 0;
      // } else {
      //   if (balance >= accountTotal) {
      //     return accountTotal;
      //   } else {
      //     return balance;
      //   }
      // }
      const payableTotal = this.payableTotal || 0; // 账单应付金额
      const tradeTotal = this.total || 0; // 账单已付金额
      const balance = this.useRest ? this.balance || 0 : 0;
      // 对于预计使用余额：
      // 如果 账单应付金额 - 账单已付金额 >= 当前拥有余额, 即当前拥有余额不够用则，当前拥有余额就是预计使用余额
      // 否则 账单应付金额 - 账单已付金额 < 当前拥有余额, 即当前拥有余额足够用且有盈余，所以预计使用余额就是： 账单应付金额 - 账单已付金额
      const ret = payableTotal - tradeTotal >= balance ? balance : payableTotal - tradeTotal;
      return Math.max(ret, 0);
    },
    // 实付金额
    actualPayAmount() {
      // 支付信息金额总和
      const total = this.total || 0;
      // 预计使用余额
      const expectUseRest = this.expectUseRest || 0;
      return expectUseRest + total;
    },
    // 对公转账
    publicAmount() {
      return this.getPublicAmount();
    },
    // 现金支付
    cashAmount() {
      return this.getCashAmount();
    },
  },
  watch: {},
  filters: {},
  directives: {},
  methods: {
    // 计算账单总金额
    getAccountTotal() {
      return this.billList.reduce((total, item) => {
        const { paymentAmount = 0 } = item;
        const sum = Number(paymentAmount);
        return sum + total;
      }, 0);
    },
    // 计算支付信息列表总金额
    getBillTotal() {
      const key = 'totalAmount';
      const list = this.tradeList;
      return list.reduce((total, item) => total + Number(item[key] || 0), 0);
    },
    // 计算支付信息列表中，对公转账金额总额
    getPublicAmount() {
      const list = this.tradeList;
      if (this.dicMap.payment_class) {
        const ret = list.filter((item) => `${item.tradeMethod}` === `${this.dicMap.payment_class.public_account}`);
        return ret.reduce((total, item) => {
          const { totalAmount = 0 } = item;
          return total + Number(totalAmount);
        }, 0);
      }
      return 0;
    },
    // 计算支付信息列表中，现金金额总额
    getCashAmount() {
      const list = this.tradeList;
      if (this.dicMap.payment_class) {
        const ret = list.filter((item) => `${item.tradeMethod}` === `${this.dicMap.payment_class.cash}`);
        return ret.reduce((total, item) => {
          const { totalAmount = 0 } = item;
          return total + Number(totalAmount);
        }, 0);
      }
      return 0;
    },

    getReqData() {
      return {
        billPaymentCode: this.getPaymentCode(this.registerMsg),
        paymentCode: this.getPaymentCode(this.registerMsg),
        billIdList: this.billList.map((item) => item.billId),
        tradeList: this.tradeList,
        useBalance: this.useRest,
        payableOrgName: this.firstOrderItem.payableOrgName,
        payableOrgId: this.firstOrderItem.payableOrgId,
      };
    },
    syncPaymentCode(data) {
      const paymentCode = typeof data === 'string' ? data : this.getPaymentCode(data || {});
      if (paymentCode) {
        // 暂存后同步支付编号，后续刷新详情优先通过支付编号查询。
        this.$set(this.registerMsg, 'billPaymentCode', paymentCode);
        this.$set(this.registerMsg, 'paymentCode', paymentCode);
      }
    },
    getRegistrationPaymentInfoReqUrl(row) {
      const paymentCode = this.getPaymentCode(row);
      if (paymentCode) {
        // 登记收款添加交易后，需通过支付编号查询最新支付详情。
        return `${apis.paymentInfoByCode}/${paymentCode}`;
      }
      return this.getPaymentInfoReqUrl(row);
    },
    onMsgStore() {
      // 新增交易信息暂存是为了保存paymentCode,不然每次调用账单详情接口，paymentCode都在变
      // 故，只要新增第一条数据时，就执行暂存
      if (this.tradeList.length === 1) {
        this.onStore(false);
      }
    },

    onCancelOrder() {
      if (this.submiting || this.relatedBillLoading || !this.visible) {
        return;
      } else {
        this.submiting = true;
      }
      this.$showConfirm(this.$t('fms_accounts_registration_dialog.nqdyqxcddzdhbzhwjyzt'))
        .then(() => {
          const billPaymentCode = this.getPaymentCode(this.registerMsg);
          const url = `${apis.paymentCancelPayment}/${billPaymentCode}`;
          this.$postJSON(url, {}, true)
            .then(() => {
              this.$message({
                type: 'success',
                message: this.$t('Common.com_handle_success'),
              });
              this.$emit('success');
              this.closeDialog();
            })
            .finally(() => {
              this.submiting = false;
            });
        })
        .catch(() => {
          this.submiting = false;
        });
    },
    closeDialog() {
      this.visible = false;
    },
    onCancel() {
      this.closeDialog();
    },
    // 暂存
    onStore(isClose = true) {
      if (this.submiting || this.relatedBillLoading || !this.visible) {
        return;
      } else {
        this.submiting = true;
      }
      if (this.payableTotal < 0) {
        this.$message.error(this.$t('fms_accounts_registration_dialog.yfjehjbnxy0'));
        this.submiting = false;
        return;
      }
      if (this.billList.length === 0) {
        this.$message.error(this.$t('fms_accounts_registration_dialog.zdlbbnwk'));
        this.submiting = false;
        return;
      }

      const reqData = this.getReqData();

      // eslint-disable-next-line consistent-return
      return this.$postJSON(this.getStockReqUrl(this.firstOrderItem.billType), reqData, true)
        .then((res) => {
          this.syncPaymentCode(res.data);
          this.$emit('success');

          if (isClose) {
            this.$message({
              type: 'success',
              message: this.$t('Common.com_handle_success'),
            });
            this.closeDialog();
          } else {
            return this.getPageInfo();
          }

          return null;
        })
        .finally(() => {
          this.submiting = false;
        });
    },
    // 保存
    onConfirm() {
      if (this.submiting || this.relatedBillLoading || !this.visible) {
        return;
      } else {
        this.submiting = true;
      }
      if (this.payableTotal < 0) {
        this.$message.error(this.$t('fms_accounts_registration_dialog.yfjehjbnxy0'));
        this.submiting = false;
        return;
      }
      if (this.billList.length === 0) {
        this.$message.error(this.$t('fms_accounts_registration_dialog.zdlbbnwk'));
        this.submiting = false;
        return;
      }
      const useRest = this.useRest;
      if (this.tradeList.length === 0) {
        if (useRest) {
          if (this.registerMsg.balance < this.payableTotal) {
            this.$message.error(this.$t('fms_accounts_registration_dialog.zfxxbnwk'));
            this.submiting = false;
            return;
          }
        } else {
          this.$message.error(this.$t('fms_accounts_registration_dialog.zfxxbnwk'));
          this.submiting = false;
          return;
        }
      }

      if (this.tradeList.length) {
        const isEmptyTradeFinishTime = this.tradeList.some((item) => !item.tradeFinishTime);
        if (isEmptyTradeFinishTime) {
          this.$message.error(this.$t('fms_accounts_registration_dialog.jyrqbnwk'));
          this.submiting = false;
          return;
        }
      }

      const reqData = this.getReqData();
      this.$postJSON(this.getSubmitReqUrl(this.firstOrderItem.billType), reqData, true)
        .then((res) => {
          this.$message({
            type: 'success',
            message: this.$t('Common.com_handle_success'),
          });

          const resData = res.data;
          // 如果后端返回的数据提示交易完成，则直接关闭dialog
          if (resData.tradeState === 10) {
            this.$emit('success');
            this.closeDialog();
            return;
          }
          this.$emit('success');
          this.closeDialog();
        })
        .finally(() => {
          this.submiting = false;
        });
    },
    // 去除传入的billData中的押金字段
    initBillList(list) {
      const ret = list.map((item) => {
        const obj = {
          ...item,
        };
        obj.depositFee = 0;
        return obj;
      });
      return ret;
    },
    // 查询账单及其关联赠送账单，赠送账单只能随主账单一并增删
    getRelatedBills(list) {
      const billList = this.formatRefundBill(this.initBillList(list || []));
      if (this.paymentOrReceivable) {
        this.billList = billList;
        return Promise.resolve();
      }

      const mainBillList = billList.filter(item => `${item.billType}` !== '19');
      const billIdList = mainBillList.map(item => item.billId);
      if (!billIdList.length) {
        this.billList = [];
        return Promise.resolve();
      }

      this.relatedBillLoading = true;
      return this.$getJSON(apis.billOrderPaymentRelatedBills, { billIdList }).then((res) => {
        const data = res.data || [];
        const relatedBillList = Array.isArray(data) ? data : data.records || data.list || [];
        this.billList = this.formatRefundBill(this.initBillList(relatedBillList));
      }).finally(() => {
        this.relatedBillLoading = false;
      });
    },
    // 添加主账单后重新查询关联赠送账单
    onAddBills(list) {
      const currentBillList = [...this.billList, ...list];
      const mainBillList = this.paymentOrReceivable ? currentBillList : currentBillList.filter(item => `${item.billType}` !== '19');
      const billList = mainBillList.filter((item, index, arr) => arr.findIndex(row => `${row.billId}` === `${item.billId}`) === index);
      this.getRelatedBills(billList);
    },
    // 删除主账单后，其关联赠送账单由接口同步移除
    onDeleteBill(row) {
      const billList = this.billList.filter((item) => {
        const isCurrentBill = `${item.billId}` === `${row.billId}`;
        const isGiveBill = `${item.billType}` === '19';
        return !isCurrentBill && (this.paymentOrReceivable || !isGiveBill);
      });
      this.getRelatedBills(billList);
    },
    getPageInfo() {
      const firstItem = { ...this.billList[0] };
      const paymentCode = this.getPaymentCode(this.registerMsg);
      if (paymentCode) {
        // 添加交易暂存后，账单行可能还没有支付编号，这里用弹窗详情里的编号兜底。
        firstItem.paymentCode = paymentCode;
        firstItem.billPaymentCode = paymentCode;
      }
      const url = this.getRegistrationPaymentInfoReqUrl(firstItem);
      return this.$getJSON(url).then((res) => {
        const data = res.data;
        if (data && data.billPayment) {
          this.isLockBill = data.billPayment.isLockBill;
        }
        this.registerMsg = data;
        this.registerMsg.balance = this.getBalance(data, 'payment-register');
        this.registerMsg.deposit = this.registerMsg.deposit || 0;
        const billList = data.orderViewList && data.orderViewList.length ? data.orderViewList : this.billList;
        if (data.tradeBoList && data.tradeBoList.length) {
          this.tradeList = [...data.tradeBoList];
          data.tradeBoList.forEach((item, index) => {
            this.$getJSON(`${apis.OssAttach}/${item.tradeId}/fms.trade.certificate`).then((imgRes) => {
              this.$set(this.tradeList[index], 'attachs', this.formatAttachs(imgRes.data));
            });
          });
        }
        if (data.billPayment && data.billPayment.isUseBalance) {
          this.useRest = true;
        }
        return this.getRelatedBills(billList);
      });
    },
  },
  created() {},
  mounted() {
    this.getDicMap('payment_class', () => {
      this.billList = this.formatRefundBill(this.initBillList(this.model.data.billData));
      this.firstOrderItem = this.billList[0];
      this.getPageInfo();
    });
  },
};
</script>

<style lang="scss">
.accounts-registration-dialog {
  .bold {
    font-weight: bold;
  }
  .expect-rest {
    margin-top: 24px;
  }
  .info-container {
    display: flex;
    .l {
      flex: 1;
      padding-right: 20px;
    }

    .r {
      width: 350px;

      .pay-info {
        .item {
          overflow: hidden;
          &:nth-child(n + 2) {
            margin-top: 4px;
          }
          .key {
            float: left;
            font-size: 12px;
            color: #4d4d4d;
            line-height: 18px;
          }
          .val {
            overflow: hidden;
            font-size: 12px;
            color: #1a1a1a;
            line-height: 18px;
            padding-left: 16px;
            white-space: normal;
          }
        }
      }

      .pay-info {
        background: #fff;
        padding: 10px;
        border: 1px solid whitesmoke;
        border-radius: 4px;
        overflow: hidden;
        border-top: 4px solid #00a0d9;

        > .title {
          line-height: 30px;
          font-size: 14px;
          margin-bottom: 10px;
          font-weight: bold;
        }

        .order-code {
          color: #4d4d4d;
          font-size: 14px;
          line-height: 20px;
          margin-bottom: 10px;
          overflow: hidden;

          .label {
            float: left;
          }
          .value {
            overflow: hidden;
            padding-left: 16px;
          }
        }

        .group {
          padding: 24px 0;
          border-top: 1px solid rgba(245, 245, 245, 1);

          // &:last-child {
          //   border-bottom: 1px solid rgba(245, 245, 245, 1);
          // }
        }

        .rest {
          overflow: hidden;
          line-height: 20px;
          .label {
            font-size: 14px;
            float: left;
            color: #4d4d4d;
          }
          .value {
            float: left;
            font-size: 14px;
            color: #1a1a1a;
            padding-left: 16px;
          }
          .use-rest {
            float: right;
            .use-label {
              float: left;
              color: #4d4d4d;
            }
            .use-cb {
              float: left;
              margin-left: 10px;
            }
          }
        }

        .amount {
          .should-pay {
            line-height: 24px;
            color: #4d4d4d;
            font-size: 14px;
          }

          .details {
            background: rgba(248, 249, 250, 1);
            padding: 16px;
            margin-top: 16px;
            .item {
              line-height: 20px;
              font-size: 14px;
              overflow: hidden;
              &:nth-child(n + 2) {
                margin-top: 12px;
              }
              .key {
                color: #4d4d4d;
                float: left;
              }
              .val {
                color: #1a1a1a;
                float: right;
              }
            }
          }

          .actual-pay {
            overflow: hidden;
            line-height: 24px;
            font-size: 14px;
            margin-top: 20px;
            .key {
              float: left;
              color: #1a1a1a;
            }
            .val {
              float: left;
              color: #00a0d9;
            }
          }
        }

        .btn-content {
          padding-top: 24px;
          padding-bottom: 10px;

          .btn {
            display: block;
            width: 100%;
            margin-left: 0 !important;
            &:nth-child(n + 2) {
              margin-top: 24px;
            }
          }
        }
      }
    }
  }
}
</style>
